import React from 'react';
import styled from 'styled-components';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';

const EmptyState = () => {
  const { t: translate } = useTranslation();

  return (
    <RootElement>
      <Typography
        sx={{
          mb: 2,
        }}
        variant="headline-medium"
      >
        {translate('We can’t seem to find any partners with that search term.')}
      </Typography>
      <Typography
        sx={{
          mb: 6,
        }}
        variant="body-copy-medium"
        className="empty-state"
      >
        {translate('There are a lot of partners to explore here, and we want to help you find the right one for your project. Please try your search by typing in a product, industry, or company name. Or use the filter menu.')}
      </Typography>
    </RootElement>
  );
};

export default EmptyState;

const RootElement = styled.div`
    .empty-state {
        max-width: 861px;
    }
`;
